<template>
  <v-layout column class="farm-card">
    <div class="text-xs-center font-weight-regular headline">Farm Details</div>
    <div class="text-xs-center caption">{{farm.name}}</div>
    <div v-if="canAccess('FARM_EDIT')" class="edit-btn">
      <v-btn fab dark small color="primary" @click="handleEditFarm(farm)" icon>
        <v-icon class="my-1">edit</v-icon>
      </v-btn>
    </div>

    <v-layout column class="px-3 py-2">
      <div class="label text-uppercase font-weight-bold px-3 py-2">Name:</div>
      <div class="value font-weight-light px-3 py-2">{{farm.name}}</div>

      <div class="label text-uppercase font-weight-bold px-3 py-2">Location:</div>
      <div class="value font-weight-light px-3 py-2">{{farm.address}}</div>

      <div class="label text-uppercase font-weight-bold px-3 py-2">City:</div>
      <div class="value font-weight-light px-3 py-2">{{farm.city}}</div>

      <div class="label text-uppercase font-weight-bold px-3 py-2">Country:</div>
      <div class="value font-weight-light px-3 py-2">{{countriesList[farm.country_code]}}</div>

      <div class="label text-uppercase font-weight-bold px-3 py-2">Certifications</div>
      <div class="px-3 py-2">
        <div class="certificate" v-for="certificate in getCertificatesForLocation(farm.id)" :key="certificate.id">
          <v-layout @click="expand(certificate)" row class="expand-header">
            <v-flex grow class="font-weight-bold text-capitalize certificate-name">{{certificate.title}}</v-flex>
            <v-flex shrink v-bind:class="{rotate: ~expandedCertificates.indexOf(certificate.id)}">
              <v-icon >
                arrow_drop_down
              </v-icon>
            </v-flex>
          </v-layout>
          <v-layout class="expand-content px-2 py-1" :class="{'show-content': ~expandedCertificates.indexOf(certificate.id)}" row wrap>
            <v-flex class="pa-2" xs6>
              <label class="pa-2 font-weight-bold text-uppercase label">Issued At</label>
              <div class="pa-2 font-weight-light value">{{formatDate(certificate.issued_at)}}</div>
            </v-flex>
            <v-flex class="pa-2" xs6>
              <label class="pa-2 font-weight-bold text-uppercase label">Expires At</label>
              <div class="pa-2 font-weight-light value">{{formatDate(certificate.expires_at)}}</div>
            </v-flex>
            <v-flex class="pa-2" xs6 v-if="certificate.issuer">
              <label class="pa-2 font-weight-bold text-uppercase label">Issuer</label>
              <div class="pa-2 font-weight-light value">{{certificate.issuer}}</div>
            </v-flex>
            <v-flex class="pa-2" xs6 v-if="certificate.issuer_url">
              <label class="pa-2 font-weight-bold text-uppercase label">Issuer Website</label>
              <div class="pa-2 font-weight-light value">{{certificate.issuer_url}}</div>
            </v-flex>
            <v-btn block color="primary" xs12 raised @click="viewCertificate(certificate)">view certificate</v-btn>
          </v-layout>
        </div>
      </div>
    </v-layout>
    <div class="text-xs-center">Secured by Hyperledger Sawtooth</div>
    <a v-if="farm.blockchain" :href="farm.blockchain.state" class="text-xs-center hash">Hash:{{farm.blockchain.address}}</a>
  </v-layout>
</template>

<script>

import { mapGetters } from 'vuex'
import { countriesList } from '@/utils/countries'
import { formatDate } from '@/utils/date'
import { canAccess } from '@/utils/permissions'

export default {
  name: 'FarmCard',
  props: {
    farm: Object
  },
  computed: mapGetters({
    getCertificatesForLocation: 'getCertificatesForLocation'
  }),
  data () {
    return {
      countriesList,
      expandedCertificates: []
    }
  },
  methods: {
    formatDate,
    canAccess,

    expand (certificate) {
      let index = this.expandedCertificates.indexOf(certificate.id)
      if (~index) {
        this.expandedCertificates.splice(index, 1)
      } else {
        this.expandedCertificates.push(certificate.id)
      }
    },

    handleEditFarm (farm) {
      this.$router.push({ name: 'farms.edit', params: { id: farm.id, farm: farm, certificates: this.getCertificatesForLocation(farm.id) } })
    },

    viewCertificate (certificate) {
      window.open(certificate.file, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>

.farm-card{
  position: relative;
}

.hash {
  font-family: monospace;
  word-break: break-all;
  text-decoration: none;
  color: #333333;
}

.edit-btn{
  position: absolute;
  top: 0px;
  right: 0px;
}

.infos-container{
  padding: 10px 25px;
}

.label{
  color: #858585;
  font-size: 12px;
}

.value{
  background: white;
  font-size: 16px;
}

.certificate .label{
  background: white;
}

.rotate{
  transform: rotateX(180deg)
}

.expand-header{
  padding: 5px 15px;
  background: #fafafa;
  cursor: pointer;
}

.expand-content{
  transition: 0.5s;
  max-height: 0;
  overflow: hidden;
}

.show-content{
  max-height: 300px;
}
</style>
